"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SummaryListItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _col = _interopRequireDefault(require("../col"));

var _row = _interopRequireDefault(require("../row"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Local
// Style
var SummaryListItem = function SummaryListItem(_ref) {
  var className = _ref.className,
      style = _ref.style,
      titleCol = _ref.titleCol,
      title = _ref.title,
      desc = _ref.desc;
  return /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "shpmtc-summary-list ".concat(className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 12,
    sm: titleCol
  }, title), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 12,
    sm: 24 - titleCol
  }, desc));
}; // Prop Types


exports.SummaryListItem = SummaryListItem;
SummaryListItem.defaultProps = {
  title: null,
  titleCol: 6,
  desc: null,
  style: null,
  className: ''
};
SummaryListItem.propTypes = {
  title: _propTypes.default.node,
  titleCol: _propTypes.default.number,
  desc: _propTypes.default.node,
  style: _propTypes.default.instanceOf(Object),
  className: _propTypes.default.string
};